import React from 'react';

export class ReportsMainLayout extends React.Component {
  setTables(tableFlags) {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ shownTables: tableFlags });
  }
}

export default ReportsMainLayout;
